import { useState, useEffect, useCallback, useContext } from "react";
import { TextField, Grid } from "@mui/material/";

import "./headerInformation.css";
import { lincolnLogo } from "../../../../../../../assets";
import { ThemeContext } from "../../../../../../../contexts";

/* eslint-disable */
const HeaderInformation = ({ openEnrollment }) => {
	const { theme } = useContext(ThemeContext);

	return (
		<div className="header-informations" id="header-informations">
			<div className="gltd-header" id="gltd-header">
				Group Long Term Disability
			</div>
			<div
				className="plan-code"
				id="plan-code"
				style={{
					color: theme.primary_color,
					fontWeight: "bold"
				}}
			>
				Plan Code: {openEnrollment.plan.plan_code}
			</div>
			<div className="enrollment-header" id="enrollment-header">
				<Grid container spacing={1}>
					<Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
						<div className="lincoln-logo">
							<img src={lincolnLogo} className="lincoln-logo" id="lincoln-logo" alt="Lincoln logo" />
						</div>
						<div className="enrollment-label">Here is your Enrollment Form</div>
						<div className="group-id">Group ID: BROOKSHIRE</div>
					</Grid>
					<Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
						<div className="lincoln-address">
							<p className="lincoln-company-text"> The Lincoln National Life Insurance Company</p>
							<p className="post-office-text"> P.O Box 2616, Omaha, NE 68103-2616</p>
							<p className="phone-text"> Phone: 800-423-2765; Fax: 877-573-6177 </p>
						</div>
						<div className="form-steps">
							<p className="steps-text"> Follow these steps to complete the form.</p>
							<p className="steps-text"> Print clearly in ink.</p>
							<p className="steps-container">
								<span className="each-steps">Step 1: </span>
								<span className="info-steps"> Fill in or confirm your personal information. </span>
							</p>
							<p className="steps-container">
								<span className="each-steps">Step 2: </span>
								<span className="info-steps"> Fill in dependent information, if any. </span>
							</p>
							<p className="steps-container">
								<span className="each-steps">Step 3: </span>
								<span className="info-steps"> Select your benefits. </span>
							</p>
							<p className="steps-container">
								<span className="each-steps">Step 4: </span>
								<span className="info-steps"> Assign beneficiaries. </span>
							</p>
							<p className="steps-container">
								<span className="each-steps">Step 5: </span>
								<span className="info-steps"> Confirm enrollment. </span>
							</p>
							<p className="steps-container">
								<span className="each-steps">Step 6: </span>
								<span className="info-steps"> Sign, date & return the form. </span>
							</p>
						</div>
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

export default HeaderInformation;
